import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingCatalogRoles = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGROLE}`, "get");
    const body = await resp.json();

    debugLogActions(':: catalogRoleActions, startLoadingCatalogRoles', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogRoles(body.catalogRoles));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogRoles = (catalogRoles) => ({
  type: types.CATALOGROLE_START_LOADING,
  payload: catalogRoles,
});

export const startLoadingCatalogRolesPaginated = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGROLE}`, `get/${page}/${size}`);
    const body = await resp.json();

     debugLogActions(':: catalogRoleActions, startLoadingCatalogRolesPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogRolesPaginated(body.catalogRolePaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogRolesPaginated = (catalogRolePaginated) => ({
  type: types.CATALOGROLE_START_LOADING_PAGINATED,
  payload: catalogRolePaginated,
});

export const selectCatalogRoles = (catalogRole) => ({
  type: types.CATALOGROLE_SELECT,
  payload: catalogRole,
});

export const catalogRoleClean = () => ({
  type: types.CATALOGROLE_CLEAN,
});

export const catalogRoleStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_CATALOGROLE}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

               debugLogActions(':: catalogRoleActions, catalogRoleStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(catalogRoleDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: catalogRoleActions, catalogRoleStartDelete', { 'error': error });
    }
  };
};

const catalogRoleDeleted = (id) => {
  return {
    type: types.CATALOGROLE_DELETE,
    payload: id,
  };
};

export const startSearchingCatalogRolePaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGROLE}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

     debugLogActions(':: catalogRoleActions, startSearchingCatalogRolePaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingCatalogRolesPaginated(body.catalogRolesPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingCatalogRolesPaginated = (catalogRolesPaginated) => ({
  type: types.CATALOGROLE_START_SEARCH_PAGINATED,
  payload: catalogRolesPaginated,
});

export const cleanSearchingCatalogRolesPaginated = () => ({
  type: types.CATALOGROLE_CLEAN_SEARCH_PAGINATED,
});

export const catalogRoleStartUpdate = (catalogRole, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_CATALOGROLE}`,
        `update/${catalogRole.id}`,
        catalogRole,
        "PUT"
      );
      const body = await resp.json();

       debugLogActions(':: catalogRoleActions, catalogRoleStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(catalogRoleUpdated(catalogRole));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-catalog-role");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: catalogRoleActions, catalogRoleStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} catalogRole
 * @returns
 */
const catalogRoleUpdated = (catalogRole) => {
  return {
    type: types.CATALOGROLE_UPDATE,
    payload: catalogRole,
  };
};

export const catalogRoleStartRegister = (catalogRole, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGROLE}`,
      "add",
      catalogRole,
      "POST"
    );

    const body = await resp.json();

     debugLogActions(':: catalogRoleActions, catalogRoleStartRegister', { 'body': body });

    if (body.ok) {
      dispatch(catalogRoleRegister(body.catalogRole));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-catalog-role");
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const catalogRoleRegister = (catalogRole) => ({
  type: types.CATALOGROLE_START_REGISTER,
  payload: catalogRole,
});

export const catalogRoleSetSearchText = (searchText) => ({
  type: types.CATALOGROLE_SET_SEARCH_TEXT,
  payload: searchText,
});

export const catalogRoleCleanSearchText = () => ({
  type: types.CATALOGROLE_SET_SEARCH_TEXT,
});
